// extracted by mini-css-extract-plugin
module.exports = {"shippingTab":"_1Jt09","selectWrap":"_1Exls","title":"zJsZX","productItem":"_2IzGC"};